import { reduxForm } from 'redux-form';

import ReportForm from './ReportForm';

export default reduxForm({ form: 'reportForm' })(ReportForm as any) as any;
